/* eslint-disable @typescript-eslint/no-explicit-any */
import { StyledOutletMiniCard } from './SearchOutletMiniCard.styles';
import { Heading, Link, Image, Icon, Types, Text, size, tags, Eyebrow } from '@marriott/mi-ui-library';
import clsx from 'clsx';
import { IMAGE_URL_DOMAIN } from '../../../modules/utils/constants/constants';
import { getTitleIconOutlet } from '../../../modules/utils/helpers';

export const SearchOutletMiniCard = (props: any) => {
  const getCardLink = () => {
    if (props?.outlet?.node?.seoUrl) {
      return `${props?.currentLocale}/dining/${props?.outlet?.node?.seoUrl}.mi`;
    }
    return '';
  };

  const isLink = getCardLink() !== '';

  const getOutletImage = () => {
    const images: { defaultImageUrl: string } = {
      defaultImageUrl: '',
    };
    let defaultImageUrl = '';
    const outletImages = [];
    if (
      props?.outlet?.node?.media?.imageConnection &&
      props?.outlet?.node?.media?.imageConnection?.edges?.length === 1
    ) {
      if (
        (props?.outlet?.node?.media?.imageConnection?.edges[0]?.node?.imageUrls?.square !== '' &&
          props?.outlet?.node?.media?.imageConnection?.edges[0]?.node?.imageUrls?.square !== null) ||
        props?.outlet?.node?.media?.imageConnection?.edges[0]?.node?.cardImages?.length > 0
      ) {
        defaultImageUrl = props?.outlet?.node?.media?.imageConnection?.edges[0]?.node?.imageUrls?.square
          ? `${IMAGE_URL_DOMAIN}${props?.outlet?.node?.media?.imageConnection?.edges[0]?.node?.imageUrls?.square}`
          : props?.outlet?.node?.media?.imageConnection?.edges[0]?.node?.cardImages[0]?.isFallBackImage
          ? props?.outlet?.node?.media?.imageConnection?.edges[0]?.node?.cardImages[0]?.dynamicMedia?.assetPath
          : props?.outlet?.node?.media?.imageConnection?.edges[0]?.node?.cardImages[0]?.defaultImageUrl?.replace(
              ':Wide-Hor?downsize=504:*',
              ':Square'
            );
        images['defaultImageUrl'] = defaultImageUrl;
        outletImages.push(images);
      } else {
        defaultImageUrl = `${props?.dynamicMedia?.assetPath}`;
        images['defaultImageUrl'] = defaultImageUrl;
        outletImages.push(images);
      }
    } else {
      const sortedImages = props?.outlet?.node?.media?.imageConnection?.edges?.sort(function (a: any, b: any) {
        return (
          Number(b.node.isPrimaryArchitectural) - Number(a.node.isPrimaryArchitectural) ||
          Number(b.node.isPrimaryServices) - Number(a.node.isPrimaryServices) ||
          Number(b.node.isSecondaryArchitectural) - Number(a.node.isSecondaryArchitectural) ||
          Number(b.node.isSecondaryServices) - Number(a.node.isSecondaryServices)
        );
      });

      if (
        sortedImages?.length > 0 &&
        sortedImages[0]?.node?.media?.imageConnection?.edges[0]?.node?.square !== '' &&
        sortedImages[0]?.node?.media?.imageConnection?.edges[0]?.node?.square !== null
      ) {
        defaultImageUrl = `${IMAGE_URL_DOMAIN}${sortedImages[0]?.node?.imageUrls?.square}`;
        images['defaultImageUrl'] = defaultImageUrl;
        outletImages.push({ ...images });
      } else {
        defaultImageUrl = `${props?.dynamicMedia?.assetPath}`;
        images['defaultImageUrl'] = defaultImageUrl;
        outletImages.push(images);
      }
    }
    return outletImages[0]?.defaultImageUrl;
  };

  const getIconClass = () => {
    const iconClass = getTitleIconOutlet(props?.outlet?.node) ? props?.diningIconPath : props?.barIconPath;
    return iconClass;
  };

  const getCardContent = () => {
    const miniCard = document.getElementById('mini-card-container');
    miniCard?.blur();

    return (
      <div className="d-flex flex-row minicard__container">
        <Image
          title=""
          defaultImageURL={getOutletImage()}
          altText={props?.outlet?.node?.name}
          customClass="minicard__image"
          loading={'eager'}
        />
        <div className="d-flex flex-column justify-content-between minicard__details">
          <div className="px-3 pt-3 pb-2 d-flex flex-column justify-content-around">
            {props?.outlet?.node?.cuisine && <Eyebrow text={props?.outlet?.node?.cuisine} />}
            <div className={clsx('d-flex flex-row align-items-baseline')}>
              <Icon iconClass={clsx('icon-decorative mr-1', getIconClass())}></Icon>
              {props?.outlet?.node?.name && (
                <Heading
                  variation={Types.headingType.subtitle}
                  titleText={props?.outlet?.node?.name}
                  fontSize={Types.size.medium}
                  customClass="minicard__outlet-name m-ellipsis-2lines m-0"
                />
              )}
            </div>
          </div>
          {props?.outlet?.node?.property?.basicInformation?.name && (
            <div className="minicard__property-name px-3 mb-2 pt-2">
              <Text
                copyText={props?.outlet?.node?.property?.basicInformation?.name}
                customClass="p-0 m-0 t-font-alt-s"
                fontSize={size.extraSmall}
                element={tags.paragraph}
              />
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <StyledOutletMiniCard
      data-component-name="mi-rnb-OutletMiniCard"
      data-testid="mi-rnb-OutletMiniCard"
      className="search-mini-card"
    >
      {isLink ? (
        <Link
          linkHref={getCardLink()}
          target={props?.openInaNewTab === true ? '_blank' : '_self'}
          linkClassName=""
          id="mini-card-container"
        >
          {getCardContent()}
        </Link>
      ) : (
        <div>{getCardContent()}</div>
      )}
    </StyledOutletMiniCard>
  );
};
